import { ApolloError } from '@apollo/client';
import { type ExamEventErrorCode } from '@exam-center/graphql';

interface CreateExamEventErrorDetails {
  code?: ExamEventErrorCode.WebRegisterConfigurationNotFound;
}

export function getExamEventCreationErrorCode(error: unknown) {
  if (!(error instanceof ApolloError)) {
    return null;
  }

  const extensions = error.cause?.extensions;
  if (!extensions || typeof extensions !== 'object' || Array.isArray(extensions)) {
    return null;
  }

  const errorCode = (extensions as CreateExamEventErrorDetails).code;

  if (!errorCode) {
    return null;
  }

  return errorCode;
}
